import api, { handleError } from '@/services/axiosInstance';
import {
  AutocompleteParams,
  AutocompleteResponseV2,
  SearchOutcomesEnrichedResponse,
  SearchOutcomesParams,
  SearchOutcomesResponse,
} from '@/types/search';

const SEARCH_AUTOCOMPLETE_URL =
  'https://api.vh3connect.io/api:f-Fs4_ed/search/autocomplete';

const SEARCH_OUTCOMES_URL =
  'https://api.vh3connect.io/api:f-Fs4_ed/search/outcomes';

const SEARCH_OUTCOMES_ENRICHED_URL =
  'https://api.vh3connect.io/api:f-Fs4_ed/search/outcomes/enriched';

export const searchApi = {
  autocomplete: async (
    params: AutocompleteParams,
    signal?: AbortSignal
  ): Promise<AutocompleteResponseV2 | undefined> => {
    try {
      const { data } = await api.get<AutocompleteResponseV2>(
        SEARCH_AUTOCOMPLETE_URL,
        {
          params: {
            q: params.q,
            ...(params.limit != null ? { limit: params.limit } : {}),
            ...(params.types ? { types: params.types } : {}),
          },
          signal,
        }
      );

      return data;
    } catch (error) {
      handleError(error, 'autocomplete');
    }
  },

  outcomes: async (
    params: SearchOutcomesParams,
    signal?: AbortSignal
  ): Promise<SearchOutcomesResponse | undefined> => {
    try {
      const { data } = await api.post<SearchOutcomesResponse>(
        SEARCH_OUTCOMES_URL,
        {
          queryText: params.queryText,
          ...(params.limit != null ? { limit: params.limit } : {}),
          ...(params.typeId ? { typeId: params.typeId } : {}),
          ...(params.categoryId ? { categoryId: params.categoryId } : {}),
          ...(params.resourceId ? { resourceId: params.resourceId } : {}),
          ...(params.contactId ? { contactId: params.contactId } : {}),
          ...(params.siteKey ? { siteKey: params.siteKey } : {}),
          ...(params.status ? { status: params.status } : {}),
          ...(params.result ? { result: params.result } : {}),
          ...(params.startDate ? { startDate: params.startDate } : {}),
          ...(params.endDate ? { endDate: params.endDate } : {}),
        },
        { signal }
      );

      return data;
    } catch (error) {
      handleError(error, 'search outcomes');
    }
  },

  outcomesEnriched: async (
    params: SearchOutcomesParams,
    signal?: AbortSignal
  ): Promise<SearchOutcomesEnrichedResponse | undefined> => {
    try {
      const { data } = await api.post<SearchOutcomesEnrichedResponse>(
        SEARCH_OUTCOMES_ENRICHED_URL,
        {
          queryText: params.queryText,
          ...(params.limit != null ? { limit: params.limit } : {}),
          ...(params.typeId ? { typeId: params.typeId } : {}),
          ...(params.categoryId ? { categoryId: params.categoryId } : {}),
          ...(params.resourceId ? { resourceId: params.resourceId } : {}),
          ...(params.contactId ? { contactId: params.contactId } : {}),
          ...(params.siteKey ? { siteKey: params.siteKey } : {}),
          ...(params.status ? { status: params.status } : {}),
          ...(params.result ? { result: params.result } : {}),
          ...(params.startDate ? { startDate: params.startDate } : {}),
          ...(params.endDate ? { endDate: params.endDate } : {}),
        },
        { signal }
      );

      return data;
    } catch (error) {
      handleError(error, 'search outcomes enriched');
    }
  },
};
